import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMatches } from '../services/matchService';

const CreateMatchPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        // Vérifier s'il existe un match en cours
        const matches = await getMatches();
        const liveMatch = matches.find(match => match.status === 'live');
        
        if (liveMatch) {
          navigate(`/live-match/${liveMatch.id}`);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des matchs', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-8 text-blue-800">Créer un nouveau match</h1>
        
        <div className="space-y-6">
          {/* Bouton pour créer un nouveau match */}
          <div 
            onClick={() => navigate('/config-match')}
            className="cursor-pointer bg-blue-600 hover:bg-blue-700 text-white rounded-lg p-6 text-center transition-all transform hover:scale-105"
          >
            <div className="text-4xl mb-2">🎮</div>
            <h2 className="text-xl font-semibold mb-2">Nouveau Match</h2>
            <p className="text-blue-100">Configurer et démarrer un nouveau match</p>
          </div>

          {/* Bouton pour voir les matchs existants */}
          <div 
            onClick={() => navigate('/matches')}
            className="cursor-pointer bg-green-600 hover:bg-green-700 text-white rounded-lg p-6 text-center transition-all transform hover:scale-105"
          >
            <div className="text-4xl mb-2">📊</div>
            <h2 className="text-xl font-semibold mb-2">Matchs Existants</h2>
            <p className="text-green-100">Voir l'historique des matchs</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateMatchPage;
